import Task from './Task';
import { createError } from '../error';

const partialClaimDeleteURL = '/partial_claim_delete';

class PartialClaimDeleteTask extends Task {
  constructor(
    $q,
    APIService,
    DataSyncService,
    PartialClaimService,
    ClaimService,
    DocumentService,
    LogService
  ) {
    super();
    this.$q = $q;
    this.APIService = APIService;
    this.DataSyncService = DataSyncService;
    this.PartialClaimService = PartialClaimService;
    this.ClaimService = ClaimService;
    this.DocumentService = DocumentService;
    this.LogService = LogService;

    this._staffingUsersId = null;
    this._eventsId = null;
  }

  /**
   * Public properties
   */

  get canExecute() {
    return this.APIService.isOnline;
  }

  set eventsId(val) {
    this._eventsId = val;
  }

  set staffingUsersId(val) {
    this._staffingUsersId = val;
  }

  /**
   * Public methods
   */

  execute() {
    const postData = {
      staffing_users_id: this._staffingUsersId,
      events_id: this._eventsId
    };
    return this.APIService.post(partialClaimDeleteURL, postData);
  }
}

export default PartialClaimDeleteTask;
